module.exports = __webpack_public_path__ + "img/banner-1.a75afb59.png";